export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';